import { useLocation } from 'react-router-dom';
import { Bell, Menu } from 'lucide-react';

const titles = {
  '/': 'Dashboard',
  '/clientes': 'Clientes',
  '/empleados': 'Empleados',
  '/servicios': 'Catálogo de Servicios',
  '/refacciones': 'Catálogo de Refacciones',
  '/relaciones': 'Relaciones de Soporte',
  '/relaciones/nueva': 'Nueva Relación de Soporte',
  '/facturas': 'Facturas',
  '/sync': 'Sincronización',
};

export function TopBar({ onToggleMenu }) {
  const { pathname } = useLocation();
  const title = titles[pathname] || (pathname.startsWith('/relaciones/') ? 'Detalle Relación' : 'VVSRS');

  return (
    <header className="h-14 shrink-0 sticky top-0 z-10 border-b border-border bg-panel flex items-center justify-between px-4 sm:px-6">
      <div className="flex items-center gap-2 min-w-0">
        <button
          onClick={onToggleMenu}
          className="md:hidden p-1.5 -ml-1.5 rounded text-slate-400 hover:text-white hover:bg-panel-2"
          title="Menú"
        >
          <Menu size={20} />
        </button>
        <h2 className="text-base font-semibold text-white tracking-wide truncate">{title}</h2>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <button className="p-2 rounded-md hover:bg-panel-2 text-slate-400 hover:text-white" title="Notificaciones">
          <Bell size={18} />
        </button>
        <span className="hidden sm:inline text-xs text-muted font-mono">
          {new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </span>
      </div>
    </header>
  );
}